import { resolveBrandRules } from '@ngb-frontend/shared/rules'

import type {
  AppLocale,
  QueryCountryCode,
  SCBrand,
} from '@ngb-frontend/shared/types'

export const getSitecoreBrand = (country: QueryCountryCode) =>
  resolveBrandRules(country).sitecoreBrand

export const buildContentQuery = (
  url: string,
  brand: SCBrand,
  locale: AppLocale,
) => {
  const query = `${url}/${locale.toLowerCase()}/shared/dictionary/?app=${brand}&tenant=Ayvens`
  return query
}
